import { DepartmentDto } from './department.dto';

export class Department {
    readonly id: string;
    readonly account: string;
    readonly abbreviation: string;
    readonly name: string;
    readonly divisionId: string;

    constructor(dto: DepartmentDto) {
        this.id = dto.id;
        this.account = dto.account;
        this.abbreviation = dto.abbreviation;
        this.name = dto.name;
        this.divisionId = dto.divisionId;
    }
}
